<template>
  <!-- 4s店合作情况统计 -->
  <div class="public-report-header-container">
    <div class="content">
      <div class="opertaion">
        <el-form label-width="120px" label-position="top" :inline="true" @submit.native.prevent>
          <el-form-item label="所属分公司">
            <el-input :title="filiale" v-model="filiale" placeholder="请选择分公司" readonly @click.native.prevent="openDialog"></el-input>
          </el-form-item>
          <el-form-item label="所属地级市">
            <!-- 选择省 -->
            <el-select v-model="city" placeholder="请选择省" @change="getAreas($event)" clearable>
              <el-option
                v-for="item in citys"
                :key="item.id"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
            <!-- 选择市 -->
            <el-select class="select-city" v-show="city" v-model="area" placeholder="请选择市" clearable>
              <el-option
                v-for="item in areas"
                :key="item.id"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="查询月份">
            <el-date-picker
              v-model="startDate"
              type="month"
              value-format="yyyy-MM"
              placeholder="选择月"
              :clearable="false"
              :editable="false">
            </el-date-picker>
            <el-button type="primary" :disabled="isLoad" @click="generate">生成</el-button>
          </el-form-item>
          <el-form-item label="数据版本">
            <div class="versions">{{ version }}</div>
          </el-form-item>
        </el-form>
      </div>
      <div class="cust-body">
        <slot></slot>
      </div>
    </div>
    <!-- 选择分公司 -->
    <div class="select-filiale">
      <el-dialog
        title="选择分公司"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        :close-on-press-escape="false"
        width="800px"
      >
        <div class="dialog-content">
          <el-tree
            show-checkbox
            node-key="id"
            ref="dialogTree"
            :load="loadNode"
            lazy
            default-expand-all
            :check-on-click-node="true"
            :expand-on-click-node="false"
            :props="{ label: 'name', children: 'zones' }"
          ></el-tree>
        </div>
        <div slot="footer" class="dialog-footer">
          <div class="dialog-operation">
            <div class="btn">
              <el-button @click="cancelAddMember">取消</el-button>
              <el-button type="primary" @click="saveSelectedMember">保存</el-button>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { ADDRESS } from '@/assets/js/address'
export default {
  name: 'public-report-header',
  props: ['version', 'isLoad'],
  data () {
    return {
      startDate: '',
      endDate: '',
      city: '',
      area: '',
      filiale: '',
      citys: [],
      areas: [],
      dialogVisible: false,
      selectList: []
    }
  },
  methods: {
    openDialog () {
      // 下拉框清空值之后 值变为了null
      if (this.city !== '' && this.city !== null) {
        this.$confirm('您已选择所属地级市，确定要选择分公司吗？注意：确定后将清空所属地级市！', `提示`, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass: 'deleMessageBox',
          center: true
        }).then(() => {
          this.city = ''
          this.area = ''
          this.dialogVisible = true
          if (this.$refs.dialogTree) {
            this.$refs.dialogTree.setCheckedKeys(this.selectList.map(e => e.id))
          }
        }).catch(() => {})
      } else {
        this.dialogVisible = true
        if (this.$refs.dialogTree) {
          this.$refs.dialogTree.setCheckedKeys(this.selectList.map(e => e.id))
        }
      }
    },
    cancelAddMember () {
      this.dialogVisible = false
    },
    getSelectList (list) {
      // 首先判断最上层节点是否勾选
      let parent = list.find(e => e.id === '0005A41F-0000-0000-0000-0000FDA5314A')
      if (parent) {
        this.filiale = parent.name
        return [{...parent}]
      } else {
        let arr = []
        // 节点下所有的子节点被勾选，才会勾选到父节点
        // 所有被勾选到父节点
        let parentIds = []
        list.forEach(e => {
          let item = list.find(x => x.id === e.parentId)
          if (item) {
            if (parentIds.findIndex(y => y.id === item.id) === -1) {
              parentIds.push({...item})
            }
          }
        })
        // 过滤父节点被勾选的子节点
        list.forEach(e => parentIds.findIndex(x => x.id === e.parentId) === -1 && arr.push({...e}))
        this.filiale = arr.map(e => e.name).join('、')
        return arr
      }
    },
    saveSelectedMember () {
      this.selectList = [...this.$refs.dialogTree.getCheckedNodes()]
      this.getSelectList(this.$refs.dialogTree.getCheckedNodes())
      this.cancelAddMember()
    },
    getAreas (e) {
      if (this.filiale !== '') {
        this.$confirm('您已选择分公司，确定要选择所属地级市吗？注意：确定后将清空分公司！', `提示`, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass: 'deleMessageBox',
          center: true
        }).then(() => {
          this.filiale = ''
          this.selectList = []
        }).catch(() => {
          this.city = ''
        })
      }
      this.area = ''
      this.areas = []
      this.$nextTick(() => {
        let arr = ADDRESS.find(x => x.city === e)
        if (arr && arr.area) {
          arr.area.forEach(e => this.areas.push({id: e.name, name: e.name}))
        } else {
          this.areas = []
        }
      })
    },
    loadNode (node, resolve) {
      if (node.level > 2) return resolve([])
      if (node.level === 0) {
        return resolve([{ id: '0005A41F-0000-0000-0000-0000FDA5314A', name: '总公司', parentId: '0005A41F-0000-0000-0000-0000FDA5314A' }])
      } else {
        this.$axios.get('/report-api/report/data/16AC44EA-3FD0-010B-CBD7-620855ADD70E', {
          params: {
            index: -1,
            size: 10,
            sort: '',
            filters: {'16AC46BB-7CD0-0128-55AA-17647A325B28': node.data.id}
          }
        }).then((res) => {
          let options = []
          let parentId = node.level === 1 ? '0005A41F-0000-0000-0000-0000FDA5314A' : node.data.id
          res.data.forEach(n => options.push({ id: n['16AC44F4-5A40-0110-E353-E98582A63C5A'], name: n['16AC44F4-C640-0112-238E-AE9C3FD7475C'], parentId: parentId }))
          return resolve(options)
        })
      }
    },
    generate () {
      /**
       * 所属公司： companyFlag
       * 省：province
       * 市：city
       * 开始时间：startDate
       * 截止时间：endDate */
      let params = {
        companyFlag: this.selectList.map(e => e.id).join(','),
        province: this.city,
        city: this.area,
        month: this.startDate
      }
      this.$emit('generate', params)
    }
  },
  created () {
    let d = new Date()
    let m = d.getMonth()
    let defaultDate = `${d.getFullYear()}-${m > 10 ? m : '0' + m}`
    this.startDate = defaultDate
    this.endDate = defaultDate
    ADDRESS.forEach(e => this.citys.push({id: e.city, name: e.city}))
  }
}
</script>

<style lang="scss">
  .public-report-header-container {
    height: 100%;
    width: 100%;
    background-color: #fff;

    & > .content {
      padding: 10px;
      height: 100%;
      box-sizing: border-box;

      .opertaion {
        .el-form {
          .versions {
            height: 30px;
            line-height: 30px;
          }

          .select-city {
            margin-left: 40px;
          }
          .el-form-item {
            padding-right: 40px;

            .el-form-item__label {
              line-height: 15px;
            }
          }
        }
      }

      .cust-body {
        height: calc(100% - 60px);
        overflow: auto;
      }
    }

    .select-filiale {
      .dialog-content {
        height: 500px;
        overflow: auto;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/custom/page/huaao/visualReport/public-report-header.vue